import { useQuery } from '@tanstack/react-query';
import { listPools } from '@/api/real-browsers';
import PoolCard from '@/components/PoolCard';

export default function Pools() {
  const { data: pools = [], isLoading } = useQuery({
    queryKey: ['pools'],
    queryFn: () => listPools(),
    refetchInterval: 5_000,
  });

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl font-semibold">Pools</h1>
        <p className="text-sm text-slate-500">
          Groups of homogeneous browser instances. Capacity + utilisation
          rolled up from instance heartbeats.
        </p>
      </div>

      {isLoading ? (
        <div className="text-sm text-slate-500">loading…</div>
      ) : pools.length === 0 ? (
        <div className="text-sm text-slate-500">No pools registered yet.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {pools.map(p => <PoolCard key={p.id} pool={p} />)}
        </div>
      )}
    </div>
  );
}
